import { Box, Typography, Avatar } from "@material-ui/core"
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'
import { Dispatch, FunctionComponent, SetStateAction, useRef } from "react"
import { AnimatedAvatar } from "../member-profile/styled"
import { useNotification } from "hooks/use-notification/useNotification"
import { BackendPartner, OnboardingQuestion } from "common/types"
import { useScreenSizes } from "hooks/use-screen-sizes/useScreenSizes"
import { Button } from 'common/atoms/Button/Button'

interface LogoProps {
  handleChange: Function
  getProcessedFile: Function
  questionIndex: number
  editProfileQuestions: OnboardingQuestion[]
  setProfileQuestions: Function
  company: BackendPartner
  fileName: string
  setFileName: Dispatch<SetStateAction<string>>
  previewImage: string
  setPreviewImage: Function
  avatarUpdated?: boolean
  setAvatarUpdated?: Function
}

const StyledButton = styled(Button)`
  && {
    height: 20px;
    text-decoration: underline;
  }
`
export const AddLogo: FunctionComponent<LogoProps> = ({ 
  handleChange,
  getProcessedFile,
  questionIndex,
  editProfileQuestions,
  setProfileQuestions,
  company,
  setFileName,
  previewImage,
  setPreviewImage,
  setAvatarUpdated
}) => {
  const theme = useTheme()
  const { notify } = useNotification()
  const { isDevice } = useScreenSizes()
  const logo = editProfileQuestions.find(x => x.question.includes('Logo'))
  const hiddenFileInput = useRef(null)
  const aws = process.env.REACT_APP_AWS_BUCKET_NAME as string

  const handleUpload = (e: any) => {
    const maxImageFileSize = 5
    const files = e.target.files
    const fsMb = files[0]?.size / (1024 * 1024);
    if(fsMb > maxImageFileSize){
      notify('error', 'Upload limit for an image is 5MB');
      e.target.value=''
      setPreviewImage(company?.logo)
      setAvatarUpdated(false)
      setFileName('')
      return false
    }
    getProcessedFile(files, ['jpeg', 'jpg', 'png'], 'stream', async ({ file }: any) => {
      const logo = editProfileQuestions.find(x => x.question.includes('Logo'))
      const fileNameArray = files[0]?.name?.toLowerCase()?.split('.')
      if (logo) {
        logo.userAnswer = JSON.stringify({ file: file, type: fileNameArray[fileNameArray.length - 1] })
        editProfileQuestions[editProfileQuestions.indexOf(logo)] = logo
        setProfileQuestions([...editProfileQuestions])
      }
      setPreviewImage(URL.createObjectURL(e.target.files[0]))
      setFileName(files[0]?.name)
      setAvatarUpdated(true)
      e.target.value=''
    })
  }

  const clearAvatar = (e) => {
    logo.userAnswer = ''
    setPreviewImage(`https://${aws}.s3.amazonaws.com/media/images/default_company_logo.png`)
    editProfileQuestions[editProfileQuestions.indexOf(logo)] = logo
    setProfileQuestions([...editProfileQuestions])
    e.target.value=''
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" width="100%" m={isDevice ? "1em 0 0 0" : "1em 0em 1.5em 0em"}>
        <Box width="33%"></Box>
        <Box position="absolute" top={isDevice? "14em" : "12em"} left="33%" display="flex" justifyContent="center" width="33%">
          <AnimatedAvatar src={previewImage || company?.logo || '/assets/logos/default_company_logo.png'} alt="company logo" style={{ width: isDevice ? '3.5em' :'5em', height: isDevice ? '3.5em' :'5em', zIndex: 9}} />
        </Box>
        <Box position="absolute" top={isDevice? "13.5em" : "11.5em"} left="33%" display="flex" justifyContent="center" width="33%">
            <Avatar src={theme.colors.supplementary} style={{ width: isDevice ? '4.5em' :'6em', height: isDevice ? '4.5em' :'6em', backgroundColor: theme.colors.supplementary}} />
          </Box>
        <Box position="absolute" top={isDevice? "18.5rem" :"15rem"} left="33%" display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="33%" height="4rem">
          <Box height="2rem" display="flex" justifyContent="center" alignItems="center" width="100%">
            <Button
              design="tertiary"
              small
              onClick={
                e => {
                  hiddenFileInput.current.click()
                }
              }
            >
              <input
                onChange={e => {
                  handleUpload(e)
                  handleChange(questionIndex, e)
                }}
                id="actual-btn"
                type="file"
                ref={hiddenFileInput}
                hidden
              />
              <Typography variant="caption">Add Logo</Typography>
            </Button>
          </Box>
          {logo?.userAnswer != '' && (
            <Box height="2rem" mt={isDevice ? "-0.6rem" : "-0.4rem"} display="flex" justifyContent="center" alignItems="center" width="100%">
              <Button
                design="tertiary"
                small
                onClick={
                  e => {
                    clearAvatar(e)
                    handleChange(questionIndex, e)
                  }
                }
              >
                <Typography variant="caption">Remove Logo</Typography>
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}